<template>
  <div class="table_wrap">
    <el-table class="list-table" header-cell-class-name="list-header" :data="memberData"
              :row-class-name="toggleCheckClass" style="width: 100%;" height="695" empty-text="데이터가 없습니다."
              @selection-change="tableSelectChange">
      <el-table-column
          type="selection"
          class-name="text-center"
          min-width="25">
      </el-table-column>
      <el-table-column
          class="table_no"
          type="index"
          label="No"
          min-width="70"
          class-name="num text-center"
          :index="tableIdx"
      >
      </el-table-column>
      <el-table-column label="지역" width="" class-name="text-center">
        <template slot-scope="scope">
                    <span>
                        {{ returnAreaName(scope.row) }}
                    </span>
        </template>
      </el-table-column>
      <el-table-column label="이름" width="" class-name="text-center" prop="m_name"></el-table-column>
      <el-table-column label="이메일" width="" class-name="text-center" prop="m_email"></el-table-column>
      <el-table-column label="휴대전화" width="" class-name="text-center" prop="m_hp"></el-table-column>
      <el-table-column label="추천인" width="200" class-name="text-center" prop="m_recommender"></el-table-column>
      <el-table-column
          label="신청 일자" min-width="" class-name="text-center">
        <template slot-scope="scope">
                    <span>
                        {{ returnDate(scope.row.created_at) }}
                    </span>
        </template>
      </el-table-column>
      <el-table-column
          label="옵션" width="85" class-name="text-center">
        <template slot-scope="scope">
          <div class="row-info">
            <el-button
                @click="goDetail(scope.row.m_idx)">
              상세
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import util from "@/mixins/util";

export default {
  name: "MemberListWaitLayout",
  mixins: [],
  inject: ['memberListSetData'],
  components: {},
  provide() {
    return {}
  },
  props: {
    memberData: {default: () => []},
    paginationData: {
      default: () => {
        return {total: 0, page: 0, size: 0,}
      }
    },
  },
  data() {
    return {
      selectArr: [],
    }
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    tableSelectChange(row) {
      this.selectArr = [];
      util.Array.each(row, (obj, index, arr) => {
        this.selectArr.push(obj.m_idx);
      });
      this.memberListSetData('selectArr', this.selectArr)
    },
    // 선택된 로우만 클래스 추가/제거 로직
    toggleCheckClass({row, rowIndex}) {
      return this.selectArr.indexOf(row.ce_idx) > -1 ? 'select' : '';
    },
    tableIdx(index) {
      return this.paginationData.total - index - (this.paginationData.page - 1) * this.paginationData.size;
    },
    returnStatusName(status) {
      return status === 1 ? '노출' : '미노출';
    },
    returnDate(date = null) {
      if (!date) {
        return '';
      }
      return this.$moment(date).format('YYYY-MM-DD HH:mm')
    },
    goDetail(idx) {
      this.$router.push(`/amidan/wait/${idx}`);
    },
    returnAreaName(row) {
      return `${row.ac_si} ${row.ac_gu}`
    }
  },
  watch: {},
}
</script>

<style scoped>

</style>